import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IWorkgroupState } from './workgroup.types';
import { IWorkgroupData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IWorkgroupState = {
  version: 1,
  workgroups: [] as IWorkgroupData[]
};

const namespaced = true;

export const workgroup: Module<IWorkgroupState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
